import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { FormVtexComponent } from './components/form-vtex/form-vtex.component';
import { DemoFaComponent } from './components/demo-fa/demo-fa.component';
import { FormCheckout2Component } from './components/form-checkout2/form-checkout2.component';
import { FormProcessorBenefitComponent } from './components/form-processor-benefit/form-processor-benefit.component';
import { FormCardRegisterComponent } from './components/form-card-register/form-card-register.component';
import { CallbackComponent } from './components/callback/callback.component';
import { AgoraSimulatorControlComponent } from './components/agora-simulator-control/agora-simulator-control.component';
import { LandingComponent } from './components/landing/landing.component';
import { FormPaylinkComponent } from './components/form-paylink/form-paylink.component';
import { IzipayGeneratorComponent } from './components/izipay-generator/izipay-generator';
import { IzipayExcelGeneratorComponent } from './components/izipay-excel-generator/izipay-excel-generator.component';
import { EstilosInyectablesComponent } from './components/estilos-inyectables/estilos-inyectables.component';
import { FormCheckoutReactQrComponent } from './components/form-checkout-react-qr/form-checkout-react-qr.component';
import { FormSavedCardComponent } from './components/form-saved-card/form-saved-card.component';
import { FormSipPayComponent } from './components/form-sip-pay/form-sip-pay.component';
import { SafePipe } from './pipes/safe.pipe';


import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { SidenavWrapperComponent } from './components/common/sidenav-wrapper/sidenav-wrapper.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatDrawerMode, MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
import { MatMenuModule } from '@angular/material/menu';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedUiModule } from './ui/shared-ui.module';
import { HlmToaster } from '@spartan-ng/helm/sonner';
import { provideSpartanHlm } from '@spartan-ng/helm/utils';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucideActivity,
  lucideBookOpen,
  lucideChevronLeft,
  lucideChevronRight,
  lucideCreditCard,
  lucideFlaskConical,
  lucideLandmark,
  lucideLink,
  lucideList,
  lucideMenu,
  lucideNfc,
  lucidePalette,
  lucideQrCode,
  lucideReceipt,
  lucideShoppingBag,
  lucideTable,
  lucideCopy,
  lucideRefreshCw,
  lucideBanknote,
  lucideInfo,
  lucideCalendar,
  lucideClock,
  lucideExternalLink,
  lucideLoader2,
  lucideShoppingCart,
  lucidePlus,
  lucideArrowLeft,
  lucideCircleCheck,
  lucideCircleX,
  lucideRotateCw,
  lucideShieldCheck,
  lucideLock,
  lucideBan,
  lucideWalletCards,
  lucideSmartphone,
} from '@ng-icons/lucide';

@NgModule({
  declarations: [
    SidenavWrapperComponent,
    AppComponent,
    FormVtexComponent,
    DemoFaComponent,
    FormCheckout2Component,
    FormProcessorBenefitComponent,
    CallbackComponent,
    AgoraSimulatorControlComponent,
    LandingComponent,
    FormPaylinkComponent,
    IzipayGeneratorComponent,
    IzipayExcelGeneratorComponent,
    EstilosInyectablesComponent,
    FormCheckoutReactQrComponent,
    FormSavedCardComponent,
    FormSipPayComponent,
    SafePipe,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatTableModule,
    MatSortModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    MatIconModule,
    MatTableModule,
    MatInputModule,
    MatSelectModule,
    MatSidenavModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatListModule,
    MatToolbarModule,
    MatCardModule,
    MatCheckboxModule,
    MatTabsModule,
    MatDialogModule,
    MatTooltipModule,
    MatRadioModule,
    MatMenuModule,
    SharedUiModule,
    FormCardRegisterComponent,
    NgIcon,
    HlmToaster,
  ],
  providers: [
    provideSpartanHlm(),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'outline', subscriptSizing: 'dynamic' },
    },
    provideIcons({
      lucideMenu,
      lucideChevronLeft,
      lucideChevronRight,
      lucideCreditCard,
      lucideQrCode,
      lucideLink,
      lucideWalletCards,
      lucideCopy,
      lucideRefreshCw,
      lucideBanknote,
      lucideInfo,
      lucideCalendar,
      lucideClock,
      lucideExternalLink,
      lucideLoader2,
      lucideShoppingCart,
      lucidePlus,
      lucideNfc,
      lucideLandmark,
      lucideActivity,
      lucideReceipt,
      lucidePalette,
      lucideList,
      lucideShoppingBag,
      lucideFlaskConical,
      lucideTable,
      lucideBookOpen,
      lucideArrowLeft,
      lucideCircleCheck,
      lucideCircleX,
      lucideRotateCw,
      lucideShieldCheck,
      lucideLock,
      lucideBan,
      lucideSmartphone,
    }),
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
